import i18n from "i18next";
import { initReactI18next } from "react-i18next";
let language = localStorage.getItem("language");
i18n.use(initReactI18next).init({
  fallbackLng: language ?? "fa",
  debug: false,
  resources: {
    en: {
      translation: require("./utility/language/en.json"),
    },
    fa: {
      translation: require("./utility/language/fa.json"),
    },
  },
});

export default i18n;
